import { render, staticRenderFns } from "./InputOptin.vue?vue&type=template&id=ba388584&scoped=true&"
import script from "./InputOptin.vue?vue&type=script&lang=js&"
export * from "./InputOptin.vue?vue&type=script&lang=js&"
import style0 from "./InputOptin.vue?vue&type=style&index=0&id=ba388584&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba388584",
  null
  
)

export default component.exports